/**
 * CPU の対戦相手（企画書 §27-5、ADR-020）。
 *
 * **値の正はここだけ。** 対戦するときに、API がこの定義から D1 の `characters` に行を作る / 更新する
 * （`battles` が外部キーで参照するため）。マイグレーションに値を書かないのは、定義と SQL の 2 か所に
 * なるのを避けるため。
 *
 * 名前付きの固定の相手にしてあるのは、「炎ゴリラに勝ちたい」と狙って工夫できるようにするため
 * （企画書 §37-3 / §37-5）。対戦ごとに作る相手は覚えられない。
 *
 * **数値を変えたら `docs/specs/cpu-battle.md` の総当たりを回し直す。**
 */
/** CPU のキャラクターの所有者。一覧・ランキング・勝敗数を数える対戦から除く目印。 */
export const CPU_OWNER_ID = 'cpu';
/** 強さの段階。素質ポイントで分ける。 */
export const CPU_TIERS = ['easy', 'normal', 'hard'];
export const CPU_OPPONENTS = [
    // よわい（素質 55）
    {
        id: 'cpu_koneko',
        name: 'こねこ丸',
        tier: 'easy',
        potentialPoints: 55,
        archetypeId: 'swift',
        elementId: 'wind',
        traitIds: ['light_weight'],
        stats: { hp: 12, atk: 12, def: 8, spd: 23 },
        specialMoveName: 'つむじかぜ ネコパンチ',
    },
    {
        id: 'cpu_doronko',
        name: 'どろんこ坊や',
        tier: 'easy',
        potentialPoints: 55,
        archetypeId: 'guard',
        elementId: 'earth',
        traitIds: ['heavy_armor'],
        stats: { hp: 18, atk: 9, def: 20, spd: 8 },
        specialMoveName: 'どろんこ ボール',
    },
    {
        id: 'cpu_chibidora',
        name: 'ちびドラ',
        tier: 'easy',
        potentialPoints: 55,
        archetypeId: 'power',
        elementId: 'fire',
        traitIds: ['flame_body'],
        stats: { hp: 14, atk: 22, def: 9, spd: 10 },
        specialMoveName: 'ちびっこ ファイヤー',
    },
    // ふつう（素質 63）
    {
        id: 'cpu_honoo_gorilla',
        name: '炎ゴリラ',
        tier: 'normal',
        potentialPoints: 63,
        archetypeId: 'power',
        elementId: 'fire',
        traitIds: ['flame_body'],
        stats: { hp: 18, atk: 24, def: 11, spd: 10 },
        specialMoveName: 'ばくねつ ゴリラパンチ',
    },
    {
        id: 'cpu_tetsukabuto',
        name: '鉄カブト',
        tier: 'normal',
        potentialPoints: 63,
        archetypeId: 'guard',
        elementId: 'earth',
        traitIds: ['heavy_armor'],
        stats: { hp: 20, atk: 11, def: 22, spd: 10 },
        specialMoveName: 'てっぺき ヘッドバット',
    },
    {
        id: 'cpu_kasakasa',
        name: 'カサカサ丸',
        tier: 'normal',
        potentialPoints: 63,
        archetypeId: 'swift',
        elementId: 'wind',
        traitIds: ['afterimage'],
        stats: { hp: 12, atk: 16, def: 7, spd: 28 },
        specialMoveName: 'カサカサ ざんぞうぎり',
    },
    // つよい（素質 74）
    {
        id: 'cpu_kaminari_ookami',
        name: '雷オオカミ',
        tier: 'hard',
        potentialPoints: 74,
        archetypeId: 'swift',
        elementId: 'thunder',
        traitIds: ['flight'],
        stats: { hp: 16, atk: 22, def: 9, spd: 27 },
        specialMoveName: 'いなずま ファング',
    },
    {
        id: 'cpu_majutsushi_mimi',
        name: 'まじゅつ師ミミ',
        tier: 'hard',
        potentialPoints: 74,
        archetypeId: 'arcane',
        elementId: 'light',
        traitIds: ['regeneration'],
        stats: { hp: 20, atk: 22, def: 15, spd: 17 },
        specialMoveName: 'きらきら ミラクルビーム',
    },
    {
        id: 'cpu_hyakume_nushi',
        name: '百目のヌシ',
        tier: 'hard',
        potentialPoints: 74,
        archetypeId: 'anomaly',
        elementId: 'dark',
        traitIds: ['one_hit_kill'],
        stats: { hp: 22, atk: 24, def: 15, spd: 13 },
        specialMoveName: 'ひゃくめ にらみ',
    },
];
export const CPU_OPPONENT_IDS = CPU_OPPONENTS.map((opponent) => opponent.id);
